import type React from "react";
import { BasicModal, Button, FlexColumn } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { ButtonsContainer, ModalMessage, ModalTitle } from "./StyledComponents";
import { MODAL_CUSTOM_STYLES } from "./constants";
import type { IConfirmationModalProps } from "./types";

export const ConfirmationModal: React.FC<IConfirmationModalProps> = ({
    isOpen,
    isAgentRunning,
    onConfirm,
    onCancel,
}) => {
    return (
        <BasicModal
            isOpen={isOpen}
            shouldCloseOnOverlayClick={true}
            onRequestClose={onCancel}
            customStyles={MODAL_CUSTOM_STYLES}
        >
            <FlexColumn>
                <ModalTitle>{translate("ai.agent.seo.modal.close.title")}</ModalTitle>
                <ModalMessage>
                    {isAgentRunning
                        ? translate("ai.agent.seo.modal.close.running.message")
                        : translate("ai.agent.seo.modal.close.message")}
                </ModalMessage>
                <ButtonsContainer>
                    <Button
                        type="flat"
                        onClick={onCancel}
                    >
                        {translate("ai.agent.seo.modal.close.cancel")}
                    </Button>
                    <Button
                        type="primary"
                        onClick={onConfirm}
                    >
                        {translate("ai.agent.seo.modal.close.confirm")}
                    </Button>
                </ButtonsContainer>
            </FlexColumn>
        </BasicModal>
    );
}; 